import { createContext, useContext } from 'react';

export type CursorMode = 'default' | 'hidden' | 'precision' | 'crosshair';

export const CURSOR_MODES: readonly CursorMode[] = [
  'default',
  'hidden',
  'precision',
  'crosshair',
] as const;

export const DEFAULT_CURSOR_MODE: CursorMode = 'default';

export const CURSOR_BODY_ATTR = 'data-cursor-mode';

export interface CursorController {
  mode: CursorMode;
  setMode: (m: CursorMode) => void;
  reset: () => void;
}

export const CursorContext = createContext<CursorController | null>(null);

export function useCursorMode(): CursorController {
  const ctx = useContext(CursorContext);
  if (ctx == null) {
    throw new Error('useCursorMode must be used inside <CursorProvider>');
  }
  return ctx;
}
